import React, { Suspense, useMemo } from 'react';
import Loading from '../../components/Loading/index.js';
import AdminContextProvider from '../../Context/Admin/index.js';
import useUser from '../../Hooks/useUser.js';

const userDashboard = React.lazy(() => import('../User/profile/account.jsx'));

const adminDashboard = React.lazy(() => import('../Admin/dashboard/index.js'));

const Dashboard = () => {
  const { userView, currentUser } = useUser();

  const Page = useMemo(() => {
    switch (true) {
      case currentUser?.role === 'admin' && !userView:
        return adminDashboard;
      case currentUser?.role === 'admin' && userView:
      case currentUser?.role === 'user':
      default:
        return userDashboard;
    }
  }, [currentUser?.role, userView]);

  return (
    <AdminContextProvider>
      <Suspense fallback={<Loading />}>
        <Page />
      </Suspense>
    </AdminContextProvider>
  );
};

export default Dashboard;
